"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderPay = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var pay_1 = require("../../model/pay");
var service_1 = require("../../../library/base/service");
var OrderPay = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(OrderPay, _super);
    function OrderPay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '订单支付';
        _this.code = '500002';
        _this.desc = '订单支付';
        _this.requestParams = new pay_1.OrderPayRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return OrderPay;
}(service_1.BaseService));
exports.OrderPay = OrderPay;
//# sourceMappingURL=orderPay.js.map